import React, { useCallback } from 'react';
import _ from "lodash";
import { LangChooserButton, LangChooserButtonProps } from '../lang-chooser-button/LangChooserButton';
import { LangInfo } from '../lang-info/LangInfo';
import { Slider } from "../../../../components/Slider/Slider";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { DropdownItemStyled } from "../../../../components/Dropdown/styled/DropdownStyled";
import type { ILocaleLang } from '../../../../app/types/appReducer.t';

interface ILangChooserSliderPropers {
    onSelectLang: (eventKey?: string | null, e?: React.SyntheticEvent<unknown>) => void,
    locales: ILocaleLang[],
    locale: string;
    toggleButtonComponent?: React.FC<LangChooserButtonProps>,
    isHideButtonArrowIcon?: boolean,
}
export const LangChooserSlider = ({
    isHideButtonArrowIcon,
    locales,
    onSelectLang,
    toggleButtonComponent
}: ILangChooserSliderPropers) => {
    const { lang } = useLangContext();

    const handleLangRowClick = useCallback((event) => {
        const value = _.get(event, ['currentTarget', 'dataset', 'value']);
        if (value) {
            onSelectLang(value);
        }
    }, [onSelectLang]);

    const ToggleComponent: React.FC<LangChooserButtonProps> = toggleButtonComponent || LangChooserButton;

    return <Slider
        toggleComponent={<ToggleComponent isHideArrowIcon={isHideButtonArrowIcon} />}
        headerContentComponent={<LangInfo langName={lang?.langName || ''} />}
    >
        {locales.map(({ value, fullName }) => (
            <Slider.Row key={value} data-value={value} onClick={handleLangRowClick}>
                <DropdownItemStyled>
                    <LangInfo langName={fullName} />
                </DropdownItemStyled>
            </Slider.Row>
        ))}
    </Slider>
};